module.exports = __webpack_public_path__ + "static/media/NO_CHEMICALS.6d8a355e.svg";